import { render } from "./ShortContentContainer.vue?vue&type=template&id=82f048ea"
import script from "./ShortContentContainer.vue?vue&type=script&lang=js"
export * from "./ShortContentContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__